export const FormatFullDateMonthYear = (
  time: string | number | Date
): string => {
  const date = new Date(time)
  if (isNaN(date.getTime())) return ''

  // Convert to UTC+7 (Vietnam timezone)
  // If the input is already in UTC, we need to add 7 hours
  // If the input is in local time, we need to convert to UTC first, then add 7 hours
  const utcTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  const utc7Date = new Date(utcTime.getTime() + 7 * 60 * 60 * 1000)

  const day = String(utc7Date.getUTCDate()).padStart(2, '0')
  const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0')
  const year = utc7Date.getUTCFullYear()
  return `${day}/${month}/${year}`
}

export const FormatFullDateMonthYearHourMinute = (
  time: string | number | Date
): string => {
  const date = new Date(time)
  if (isNaN(date.getTime())) return ''

  // Convert to UTC+7 (Vietnam timezone)
  const utcTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  const utc7Date = new Date(utcTime.getTime() + 7 * 60 * 60 * 1000)

  const day = String(utc7Date.getUTCDate()).padStart(2, '0')
  const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0')
  const year = utc7Date.getUTCFullYear()
  const hours = String(utc7Date.getUTCHours()).padStart(2, '0')
  const minutes = String(utc7Date.getUTCMinutes()).padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}`
}

export const FormatFullDateTimeWithAMPM = (
  time: string | number | Date
): string => {
  const date = new Date(time)
  if (isNaN(date.getTime())) return ''

  // Convert to UTC+7 (Vietnam timezone)
  const utcTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  const utc7Date = new Date(utcTime.getTime() + 7 * 60 * 60 * 1000)

  const day = String(utc7Date.getUTCDate()).padStart(2, '0')
  const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0')
  const year = utc7Date.getUTCFullYear()

  let hours = utc7Date.getUTCHours()
  const minutes = String(utc7Date.getUTCMinutes()).padStart(2, '0')
  const seconds = String(utc7Date.getUTCSeconds()).padStart(2, '0')

  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours ? hours : 12 // 0 giờ => 12 AM
  const strHours = String(hours).padStart(2, '0')

  return `${day}/${month}/${year} ${strHours}:${minutes}:${seconds}${ampm}`
}

export const FormatFullDateMonthYearHourMinuteSecond = (
  time: string | number | Date
): string => {
  const date = new Date(time)
  if (isNaN(date.getTime())) return ''

  // Convert to UTC+7 (Vietnam timezone)
  const utcTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  const utc7Date = new Date(utcTime.getTime() + 7 * 60 * 60 * 1000)

  const day = String(utc7Date.getUTCDate()).padStart(2, '0')
  const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0')
  const year = utc7Date.getUTCFullYear()

  let hours = utc7Date.getUTCHours()
  const minutes = String(utc7Date.getUTCMinutes()).padStart(2, '0')
  const seconds = String(utc7Date.getUTCSeconds()).padStart(2, '0')

  hours = hours % 12
  hours = hours ? hours : 12 // 0 giờ => 12 AM
  const strHours = String(hours).padStart(2, '0')

  return `${year}/${month}/${day} ${strHours}:${minutes}:${seconds}`
}

export const formatMinutes = (minutes: number) => {
  if (typeof minutes !== 'number' || minutes < 0 || !minutes) return '0 mins'

  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60

  if (hours === 0) return `${mins} mins`
  if (mins === 0) return `${hours}hrs`
  return `${hours} hrs ${mins} mins`
}
